let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("clL3C")).then(() => parcelRequire('1QTjA'));